'use client';

import {Link} from '@tanstack/react-router';
import BananiLogo from '@/icons/banani-logo-small.svg';
import ToHomeIcon from '@/icons/toHome.svg';

type AccessLevel = 'owner' | 'viewer' | 'unauthenticated';

type Props = {
  projectName: string;
  accessLevel: AccessLevel;
};

const toolbarClass =
  'shadow-ui-sm absolute left-1 top-1 z-40 flex h-12 min-w-0 max-w-64 flex-row items-center gap-2 rounded-2xl bg-white px-3';

export function ViewerToolbar({projectName, accessLevel}: Props) {
  const content = (
    <>
      <span className='flex-shrink-0'>
        {accessLevel === 'unauthenticated' ? (
          <BananiLogo className='h-6 w-6' />
        ) : (
          <ToHomeIcon className='h-6 w-6' />
        )}
      </span>
      <span className='truncate text-sm font-semibold text-black'>
        {projectName || 'Untitled'}
      </span>
    </>
  );

  if (accessLevel === 'unauthenticated') {
    return (
      <a
        href='https://banani.co'
        target='_blank'
        rel='noopener noreferrer'
        className={toolbarClass}
      >
        {content}
      </a>
    );
  }

  return (
    <Link to='/' className={toolbarClass}>
      {content}
    </Link>
  );
}
